import React, { useEffect, useState } from "react";
import "./listQuestion.scss";

import HeaderBar from "../../components/headerBar/HeaderBar";
import SearchInput from "../../components/searchInput/SearchInput";
import AnswerQuestionDetails from "../../components/answerQuestionDetails/AnswerQuestionDetails";

import { t } from "i18next";
import { Col, Row, Stack } from "react-bootstrap";
import QuestionBox from "./components/questionBox/QuestionBox";
import { useScreenSize } from "../../ScreenSizeContext";
import { useNavigate, useParams } from "react-router-dom";
import { getListQuestion, getSingleQuestion } from "./api/listQuestionApi";
import { isEmpty } from "../../utils/validation";

const ListQuestion = () => {
  const navigate = useNavigate();
  const isPC = useScreenSize();
  const { id_association } = useParams();

  const [search, setSearch] = useState();

  const [listQuestion, setListQuestion] = useState([]);
  const [filteredListQuestion, setFilteredListQuestion] = useState([]);

  const [questionData, setQuestionData] = useState([]);

  const refreshContent = (id) => {
    getListQuestion({ id_association }).then((res) => {
      setListQuestion(res);
      setFilteredListQuestion(res);
    });

    if (id) {
      handleClick(id);
    }
  };

  //Al caricamento della pagina
  useEffect(() => {
    refreshContent();
  }, [id_association]);

  const searchFunction = () => {
    if (search) {
      setFilteredListQuestion(
        listQuestion.filter((question) => {
          const questions = question.question?.toLowerCase() || "";

          return questions.includes(search.toLowerCase());
        })
      );
    } else {
      setFilteredListQuestion(listQuestion);
    }
  };

  const handleClick = (id) => {
    if (isPC)
      getSingleQuestion({ id_association, id_question: id })
        .then((res) => setQuestionData(res))
        .catch((err) => console.error(err));
    else navigate(id.toString());
  };

  return (
    <>
      <HeaderBar back={true} title={t("list_question.title")} />
      <div className="container-responsive container-list-question m-2 h-100">
        <Row>
          <Col xs={12} sm={12} md={12} lg={6}>
            <Stack gap={2} className="">
              <SearchInput
                search={search}
                setSearch={setSearch}
                searchFunction={searchFunction}
              />
              {filteredListQuestion.map((item, index) => (
                <QuestionBox
                  key={index}
                  image={
                    item.image
                      ? "data:" + item.image_type + ";base64," + item.image
                      : "/no_img.png"
                  }
                  question={item.question}
                  id={item.id}
                  displayed={!!item.displayed}
                  handleClick={handleClick}
                  datetimeSending={item.datetime_sending}
                />
              ))}
            </Stack>
          </Col>
          {isPC ? (
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={6}
              className="d-flex justify-content-center h-100"
            >
              {!isEmpty(questionData) ? (
                <div className="w-100 p-3 container-on-right">
                  <AnswerQuestionDetails
                    id={questionData.id_question}
                    image={
                      questionData.image
                        ? "data:" +
                          questionData.image_type +
                          ";base64," +
                          questionData.image
                        : "/no_img.png"
                    }
                    name={questionData.name_association}
                    datetime={questionData.datetime_sending}
                    question={questionData.title}
                    answer={questionData.body}
                    refreshContent={() =>
                      refreshContent(questionData.id_question)
                    }
                  />
                </div>
              ) : null}
            </Col>
          ) : null}
        </Row>
      </div>
    </>
  );
};

export default ListQuestion;
